import React from "react";
import Grid from "@material-ui/core/Grid";
import FilledDateTextFieldLight from "../FilledDateTextFieldLight";
import QuestionContainer from "./QuestionContainer";
export default ({ question, positionDisplay }) => {
  return (
    <Grid data-testid="question-date-header" container direction="column">
      <Grid item>
        <QuestionContainer
          title={question.title}
          positionDisplay={positionDisplay}
          instructions={question.instructions}
          displayInstructionAsIcon={question.displayInstructionAsIcon}
          children={
            <FilledDateTextFieldLight
              style={{ backgroundColor: "white", color: "black" }}
              variant="filled"
              InputProps={{
                readOnly: true,
              }}
            />
          }
        />
      </Grid>
    </Grid>
  );
};
